<div class="modal-form container">

    

    <div>
        <div class="float-left">
            <h2 mat-dialog-title class="jumbotron-heading">Public Records</h2>
        </div>
        <div class="float-end">
            <div *ngIf="showHistory$ | async"><a (click)="onSearchPublicRecords()"><fa-icon style="font-size:18px;" icon="search"></fa-icon> New Search</a></div>
            <div *ngIf="showSelectedPR$ | async"><a (click)="onShowHistory()">Show History</a></div>
        </div>
        <div style="clear:both;"></div>
    </div>


    <lgv-loading-indicator *ngIf="isLoading$ | async"></lgv-loading-indicator>

    <mat-dialog-content class="mat-typography">


        <!--Show History-->
        <ng-container *ngIf="showHistory$ | async">
            <div class="row">

                <!--<div class="Vert-15 col-md-12"></div>
                <div class="col-md-12"><a (click)="onSearchPublicRecords()">New Search</a></div>-->

                <div class="Vert-15 col-md-12"></div>

                <div class="col-12">
                    <div *ngIf="publicRecordsResult$ | async as prResult">
                        <h4>Public Record History</h4>
                        <table class='table table-striped table-bordered'>
                            <thead>
                                <tr>
                                    <th>Request Date</th>
                                    <!--<th>Status</th>-->
                                    <th>Action</th>
                                </tr>
                            </thead>
                            <tbody>
                                <tr *ngFor="let pr of prResult.publicRecords">
                                    <td>{{pr.result.createdTimestamp | date:'short' }}</td>
                                    <!--<td>{{pr.result.requestStatus}}</td>-->
                                    <td>
                                        <a title="View Public Records" (click)="onViewPublicRecord(pr)">View</a>
                                    </td>
                                </tr>
                            </tbody>
                        </table>
                    </div>
                </div>
            </div>

        </ng-container>

        <!--Show Selected PR-->
        <ng-container *ngIf="showSelectedPR$ | async">
<!--            <div><a (click)="onShowHistory()">Show History</a></div>-->

            <lus-public-record-result [PublicRecord$]="selectedPublicRecord$" [ShowMakeCurrentButton]="true"></lus-public-record-result>

        </ng-container>

    </mat-dialog-content>

    <div class="Vert-10"></div>

    <div class="row">
        <div class="col-12" align="end">
            <button mat-stroked-button (click)="onCancel()" class="btn btn-secondary float-end" style="margin-right:10px;">Close</button>
        </div>
    </div>

    <div class="Vert-15"></div>

</div>
